<template>
    <div class="project-enrollment-chart" :class="{loading: loading}">
        <div :id="chartWrapperId" class="chart-container"></div>
    </div>

</template>

<script>
import Highcharts from "highcharts";

export default {
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  created() {
    this.init();
  },

  data() {
    return {
      loading: false,

      metrics: [],
    };
  },

  computed: {
    chartWrapperId() {
      return Math.random().toString(36).substr(2, 10) + "_chart";
    },

    enrollmentSeriesData() {
      return {
        color: "rgb(12 129 144)",
        name: "Occupancy Enrollment",
        data: _.reduce(
          this.metrics,
          function (carry, metric) {
            if (metric.category === "enrollment_percentage") {
              carry.push({
                x: new Date(metric.applicable_at),
                y: metric.value,
                name: "Occupancy Enrollment",
              });
            }

            return carry;
          },
          []
        ),
      };
    },

    efficiencySeriesData() {
      return {
        color: "rgb(127, 19, 127)",
        name: "Total Unit Enrollment",
        data: _.reduce(
          this.metrics,
          function (carry, metric) {
            if (metric.category === "efficiency_percentage") {
              carry.push({
                x: new Date(metric.applicable_at),
                y: metric.value,
                name: "Total Unit Enrollment",
              });
            }

            return carry;
          },
          []
        ),
      };
    },

    chartData() {
      return {
        chart: {
          type: "spline",
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        xAxis: {
          type: "datetime",
          tickInterval: 3600 * 24000 * 7, // 1 week
        },
        yAxis: {
          title: {
            text: "Percentage",
          },
          max: 100,
          min: 0,
          tickAmount: 6,
        },
        tooltip: {
          formatter() {
            return (
              '<span style="color:' +
              this.color +
              '">' +
              this.x.toLocaleString("en-US", {
                dateStyle: "short",
              }) +
              "</span>" +
              "<br>" +
              "<b>" +
              this.y +
              "%</b> " +
              _.startCase(this.key)
            );
          },
        },
        plotOptions: {
          spline: {
            lineWidth: 4,
            pointStart: 0,
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
        },
        legend: {
          enabled: true,
        },
        series: [this.enrollmentSeriesData, this.efficiencySeriesData],
      };
    },
  },

  methods: {
    init() {
      this.loading = true;

      return this.loadMetrics()
        .finally(() => {
          this.initChart();

          this.loading = false;
        })
        .catch(this.$root.handleErrors);
    },

    initChart() {
      Highcharts.chart(this.chartWrapperId, this.chartData);
    },

    loadMetrics() {
      var url =
        "/api/metrics?&metricable_type=App\\Project&metricable_id=" +
        this.projectId;

      return axios.get(url).then((response) => {
        this.$set(this, "metrics", response.data.Metrics);
      });
    },
  },
};
</script>
